import { useState } from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { api, apiError } from "../api";
import { useLang } from "../i18n";

export const NewsletterForm = ({ compact = false }) => {
    const { t } = useLang();
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            const { data } = await api.post("/newsletter", { email });
            setDone(true);
            if (data.status === "already") setError("");
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusy(false);
        }
    };

    if (done) {
        return (
            <div data-testid="newsletter-success" className="flex items-center gap-3 rounded-2xl border border-lakou-gold/30 bg-lakou-gold/10 px-5 py-4">
                <Check size={18} className="text-lakou-gold" />
                <span className="text-sm text-lakou-cream">{t("newsletter_done")}</span>
            </div>
        );
    }

    return (
        <form onSubmit={submit} className={compact ? "flex gap-2" : "flex flex-col sm:flex-row gap-3"}>
            <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email-input"
                className="flex-1 rounded-full border border-lakou-gold/25 bg-lakou-coal/80 px-5 py-3.5 text-sm text-lakou-cream placeholder:text-lakou-sand focus:outline-none focus:border-lakou-gold transition-colors"
            />
            <motion.button
                whileTap={{ scale: 0.97 }}
                type="submit"
                disabled={busy}
                data-testid="newsletter-submit"
                className="rounded-full bg-lakou-orange hover:bg-lakou-gold text-white hover:text-lakou-ink font-display font-bold text-xs uppercase tracking-[0.15em] px-7 py-3.5 transition-colors duration-300 disabled:opacity-60"
            >
                {busy ? "…" : t("newsletter_btn")}
            </motion.button>
            {error && <p data-testid="newsletter-error" className="text-xs text-lakou-orangelight sm:basis-full">{error}</p>}
        </form>
    );
};
